
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/graphical-abstract-maker",
      function () {
        return require("private-next-pages/graphical-abstract-maker.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/graphical-abstract-maker"])
      });
    }
  